import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  loadingToggleAction,
  TwoFactorAuthDerive,
} from "../../store/actions/AuthActions";
import axios from "axios";
import { API_URL } from "../../config";
import ihub from "../../images/ihub.png";
import ssip from "../../images/ssip.png";
import meity from "../../images/meity.png";
import startup_india from "../../images/startup_india.jpeg";
import nvidia from "../../images/nvidia.webp";
import KSPCFE from "../../images/KSPCFE.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

import Swal from "sweetalert2";
import { toast } from "react-toastify";
import {
  ArrowRight,
  CheckCircle2,
  Briefcase,
  Zap,
  Sparkles,
  Users,
  Layers,
  Lock,
  Mail,
  Eye,
  EyeOff,
  Brain,
  FileText,
  MousePointerClick,
  ShieldCheck,
  Calendar,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { motion } from "framer-motion";

function Login(props) {
  let history = useHistory();
  const [college_email, setEmail] = useState("");
  const [college_password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [ipAddress, setIpAddress] = useState("127.0.0.1");
  const [location, setLocation] = useState("unknown");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // Testimonials state
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [testimonialsLoading, setTestimonialsLoading] = useState(false);

  const supportersImage = [
    { name: "ihub", src: ihub },
    { name: "ssip", src: ssip },
    { name: "meity", src: meity },
    { name: "nvidia", src: nvidia },
    { name: "KSPCFE", src: KSPCFE },
    { name: "startup_india", src: startup_india },
  ];

  // Interactive Capabilities Bento States
  const [capPortal, setCapPortal] = useState("tpo");
  const [capDispatch, setCapDispatch] = useState("idle");
  const [studentInterestStatus, setStudentInterestStatus] = useState("idle");

  useEffect(() => {
    const fetchIpAndLocation = async () => {
      try {
        const ipResponse = await axios.get("https://api.ipify.org?format=json");
        const ipAddr = ipResponse.data.ip;
        setIpAddress(ipAddr);

        const locationResponse = await axios.get(
          `http://ip-api.com/json/${ipAddr}`,
        );
        const loc =
          `${locationResponse.data.city}, ${locationResponse.data.country}` ||
          "unknown";
        setLocation(loc);

        localStorage.setItem("user_ip_address", ipAddr);
        localStorage.setItem("user_location", loc);
      } catch (error) {
        try {
          const response = await axios.get("https://ipwho.is/");
          const ipAddr = response.data.ip;
          const loc =
            `${response.data?.city}, ${response.data?.country}` || "unknown";
          setIpAddress(ipAddr);
          setLocation(loc);
          localStorage.setItem("user_ip_address", ipAddr);
          localStorage.setItem("user_location", loc);
        } catch (fallbackError) {
          setIpAddress("127.0.0.1");
          setLocation("unknown");
          localStorage.setItem("user_ip_address", "127.0.0.1");
          localStorage.setItem("user_location", "unknown");
        }
      }
    };
    fetchIpAndLocation();

    const savedEmail = localStorage.getItem("college_email");
    const savedPassword = localStorage.getItem("college_password");
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
    localStorage.removeItem("otp_already_generated");
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCapDispatch((prev) => {
        if (prev === "idle") return "processing";
        if (prev === "processing") return "sent";
        return "idle";
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Fetch testimonials from API
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setTestimonialsLoading(true);
        const response = await axios.get(
          "https://govtjobsapi.governmentjobsforgraduates.com/api/web/WebUser/get_testimonials",
        );
        if (response.data && response.data.data) {
          // Map API response to match component structure
          const mappedTestimonials = response.data.data.map((item) => ({
            id: item.id,
            quote: item.testimonial_text,
            author: item.reviewer_name,
            role: item.reviewer_position,
            org: item.college_name,
            rating: parseInt(item.rating) || 5,
            profile_picture: item.profile_picture,
          }));
          setTestimonials(mappedTestimonials);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        // Fallback to empty array if API fails
        setTestimonials([]);
      } finally {
        setTestimonialsLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  const handleSimulateStudentInterest = () => {
    if (studentInterestStatus !== "idle") return;
    setStudentInterestStatus("submitting");
    setTimeout(() => {
      setStudentInterestStatus("done");
    }, 1200);
  };

  // Navigation handlers for testimonials
  const handlePreviousTestimonials = () => {
    setTestimonialIndex((prev) => {
      const newIndex = prev - 3;
      return newIndex < 0 ? 0 : newIndex;
    });
  };

  const handleNextTestimonials = () => {
    setTestimonialIndex((prev) => {
      const newIndex = prev + 3;
      return newIndex >= testimonials.length - 3
        ? Math.max(0, testimonials.length - 3)
        : newIndex;
    });
  };

  // Get current 3 testimonials to display
  const getCurrentTestimonials = () => {
    if (testimonials.length === 0) return [];
    const start = testimonialIndex;
    const end = Math.min(start + 3, testimonials.length);
    return testimonials.slice(start, end);
  };

  const getDeviceInfo = () => {
    if (navigator.userAgentData) {
      const deviceInfo = navigator.userAgentData.brands
        .map((brand) => `${brand.brand} ${brand.version}`)
        .join(", ");
      localStorage.setItem("user_device_info", deviceInfo);
      return deviceInfo;
    } else {
      const deviceInfo = navigator.userAgent;
      localStorage.setItem("user_device_info", deviceInfo);
      return deviceInfo;
    }
  };

  const validateInputs = () => {
    let errorMessages = [];
    if (!college_email) {
      errorMessages.push("Email is Required");
    }
    if (!college_password) {
      errorMessages.push("Password is Required");
    }
    return errorMessages;
  };

  const handleLoginError = (data) => {
    Swal.close();
    if (data.is_locked) {
      toast.error(data.message || "Account is locked.");
    } else if (data.in_active) {
      toast.error(data.message || "Account is inactive.");
    } else {
      toast.error(data.message || "Invalid Credentials");
    }
  };

  const handleApi = async (e) => {
    e.preventDefault();

    const deviceInfo = getDeviceInfo();
    const payload = { college_email, college_password };
    const params = new URLSearchParams(payload);

    const errorMessages = validateInputs();

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(", "));
      return;
    }

    params.append("ip_address", ipAddress);
    params.append("device_info", deviceInfo);
    params.append("location", location);

    try {
      setIsLoading(true);
      Swal.fire({
        title: "Signing in...",
        text: "Please wait while we process your authentication",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      dispatch(loadingToggleAction(true));
      const result = await axios.post(
        `${API_URL}/api/freshment_portal_apis/College/login`,
        params,
      );

      if (result.data.success) {
        onLogin(e, result.data, ipAddress, deviceInfo, location);
      } else {
        handleLoginError(result.data);
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.close();
      toast.error("Something went wrong!");
    } finally {
      dispatch(loadingToggleAction(false));
      setIsLoading(false);
    }
  };

  const onLogin = (e, result, ipAddress, deviceInfo, location) => {
    e.preventDefault();

    if (rememberMe) {
      localStorage.setItem("college_email", college_email);
      localStorage.setItem("college_password", college_password);
    } else {
      localStorage.removeItem("college_email");
      localStorage.removeItem("college_password");
    }

    dispatch(loadingToggleAction(true));
    dispatch(
      TwoFactorAuthDerive(result, history, ipAddress, deviceInfo, location),
    );
  };

  const [isTransitioning, setIsTransitioning] = useState(true);
  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {
    const updateCardsPerView = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setCardsPerView(1);
      } else if (width < 992) {
        setCardsPerView(2);
      } else {
        setCardsPerView(3);
      }
    };

    updateCardsPerView();
    window.addEventListener("resize", updateCardsPerView);
    return () => window.removeEventListener("resize", updateCardsPerView);
  }, []);

  // Extended list: original + first `cardsPerView` items cloned at the end
  const extendedTestimonials = [
    ...testimonials,
    ...testimonials.slice(0, cardsPerView),
  ];

  useEffect(() => {
    if (testimonials.length <= cardsPerView) return;

    const interval = setInterval(() => {
      setTestimonialIndex((prev) => prev + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  // When we've scrolled past the real items into the cloned ones, snap back invisibly
  useEffect(() => {
    if (testimonialIndex === testimonials.length) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false); // disable animation for the snap
        setTestimonialIndex(0); // jump back to real index 0
      }, 600); // matches the transition duration below

      return () => clearTimeout(timeout);
    } else {
      setIsTransitioning(true); // re-enable animation for normal moves
    }
  }, [testimonialIndex, testimonials.length]);

  return (
    <div style={styles.page}>
      {/* Background Decorative Gradients */}
      <div style={styles.glowLeft} />
      <div style={styles.glowRight} />
      <div style={styles.glowBottom} />

      {/* Hero Section with Split Login */}
      <section style={styles.heroSection}>
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column: Premium Branding & Vision */}
            <div className="col-lg-7 mb-5 mb-lg-0 pr-lg-5">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={styles.eyebrowBadge}
              >
                <Sparkles
                  style={{ width: "14px", height: "14px", color: "#FF5F14" }}
                />
                <span>Reimagining Campus Placements with AI</span>
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className={"font-display h1"}
                style={styles.h1}
              >
                EduConnectPro AI CoPilot — <br />
                <span className="font-display" style={{ color: "#FF5F14" }}>
                  Where Academic Learning Meets Industry Intelligence
                </span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                style={styles.heroDesc}
                className="heroDesc"
              >
                EduConnectPro AI CoPilot connects universities with industry
                through AI-driven skill intelligence, recruiter collaboration
                and AI-powered interview preparation — creating graduates who
                are ready for the evolving demands of industry.
              </motion.p>

              {/* Micro bullet items for trust */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                style={styles.trustGrid}
              >
                <div style={styles.trustItem}>
                  <CheckCircle2
                    style={{ width: "20px", height: "20px", color: "#10b981" }}
                  />
                  <span className="trustText" style={styles.trustText}>
                    AI CoPilot for TPOs
                  </span>
                </div>
                <div style={styles.trustItem}>
                  <CheckCircle2
                    style={{ width: "20px", height: "20px", color: "#10b981" }}
                  />
                  <span className="trustText" style={styles.trustText}>
                    300+ HR Contacts / Month
                  </span>
                </div>
                <div style={styles.trustItem}>
                  <CheckCircle2
                    style={{ width: "20px", height: "20px", color: "#10b981" }}
                  />
                  <span className="trustText" style={styles.trustText}>
                    Prepare for Interview with AI CoPilot
                  </span>
                </div>
                <div style={styles.trustItem}>
                  <CheckCircle2
                    style={{ width: "20px", height: "20px", color: "#10b981" }}
                  />
                  <span className="trustText" style={styles.trustText}>
                    Industry Skill Intelligence
                  </span>
                </div>
              </motion.div>
            </div>

            {/* Right Column: Embedded Portal Login Card */}
            <div className="col-lg-5">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                style={styles.loginCard}
              >
                <div style={styles.loginCardGlow} />

                <div className="mb-4">
                  <h3 className="font-display" style={styles.loginCardTitle}>
                    Sign In to Dashboard
                  </h3>
                  <p style={styles.loginCardSubtext}>
                    Enter your credential keys below to access the platform.
                  </p>
                </div>

                <form onSubmit={handleApi}>
                  <div className="mb-3">
                    <label style={styles.formLabel}>Institutional Email</label>
                    <div style={styles.inputWrapper}>
                      <span style={styles.inputIcon}>
                        <Mail style={{ width: "16px", height: "16px" }} />
                      </span>
                      <input
                        type="email"
                        value={college_email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="name@university.edu"
                        style={styles.inputField}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <label style={styles.formLabel}>Secure Password</label>
                      <a
                        href="/page-forgot-password"
                        className="underline-link"
                        style={styles.forgotLink}
                      >
                        Forgot password?
                      </a>
                    </div>
                    <div style={styles.inputWrapper}>
                      <span style={styles.inputIcon}>
                        <Lock style={{ width: "16px", height: "16px" }} />
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        value={college_password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••••••"
                        style={styles.inputField}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={styles.eyeBtn}
                      >
                        {showPassword ? (
                          <EyeOff style={{ width: "16px", height: "16px" }} />
                        ) : (
                          <Eye style={{ width: "16px", height: "16px" }} />
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center mb-4">
                    <input
                      id="remember-me"
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      style={styles.checkbox}
                    />
                    <label htmlFor="remember-me" style={styles.checkboxLabel}>
                      Remember my access parameters
                    </label>
                  </div>

                  <button
                    className="orangeBtn"
                    type="submit"
                    disabled={isLoading}
                    style={{
                      ...styles.submitButton,
                      opacity: isLoading ? 0.6 : 1,
                    }}
                  >
                    {isLoading ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm text-light mr-2"
                          role="status"
                        ></div>
                        <span>Verifying credential codes...</span>
                      </>
                    ) : (
                      <span>Authenticate Sign In</span>
                    )}
                  </button>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      <style>
        {`      
           .secondary-btn:hover {
            background-color: rgb(255 255 255 / 8%) !important;
          }
            @media (max-width:960px)
            {
              .h1{        font-size: 2.05rem !important;}
              .h2{        font-size: 1.8rem !important;}
              .heroDesc{font-size:12px !important;}
            }
            @media (max-width:768px)
            {
              .ctaTitle{font-size: 32px !important;}
              .ctaDesc{font-size: 12px !important;}
            }
              @media (max-width: 640px)
              {
                .testimonial_heading{font-size:25px !important;}
               
              }
              @media (max-width: 540px)
              {
                .superchargeDesc{font-size:11px !important;}
                .cardDesc{font-size:12px !important;}
                 .ctaTitle{font-size: 25px !important;}
                 .ctaDesc{font-size: 10px !important;}
              }
            @media (max-width:480px)
            {
              .heroDesc{font-size:10px !important;}
              .trustText{font-size: 10px !important;}
              .heading{font-size:25px !important;}
              .subtext{font-size:11px !important;}
              .interestButton{font-size:8.5px !important;} 
              .testimonial_heading{font-size:20px !important;}
              .ctaTrustRow{font-size:7px !important;}
              .badgeText{font-size: 9px !important;}
            }
          
        `}
      </style>

      {/* Supercharge Your Placement Cell Section with 300+ Leads UI */}
      <section style={styles.superchargeSection}>
        <div style={styles.superchargeDeco} />

        <div className="container position-relative" style={{ zIndex: 10 }}>
          <div className="row align-items-center">
            {/* Left: Branding & Text */}
            <div className="col-lg-6 mb-5 mb-lg-0">
              <span style={styles.superchargeEyebrow}>
                SUPERCHARGE YOUR PLACEMENT CELL WITH AI COPILOT
              </span>
              <h2 className="font-display h2" style={styles.h2}>
                Empower Your Campus with <br />
                <span className="font-display" style={{ color: "#FF5F14" }}>
                  EduConnectPro
                </span>
              </h2>
              <p className="superchargeDesc" style={styles.superchargeDesc}>
                Transform your Training & Placement Cell into an AI-powered
                career intelligence hub. Bridge the gap between university
                syllabus and industry expectations with intelligent employer
                engagement, skill intelligence, interview preparation, and
                access fresh monthly recruiter contacts — all from one unified
                platform.
              </p>

              <div style={styles.featuresList}>
                {/* Feature 1 */}
                <div className="feature-item-hover" style={styles.featureItem}>
                  <div className="feature-item-bar" />
                  <div
                    className="feature-icon-hover"
                    style={styles.featureIconWrap}
                  >
                    <Users style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div>
                    <h4
                      className="font-sans feature-title-hover"
                      style={styles.featureTitle}
                    >
                      300+ Verified HR & Recruiter Contacts Every Month
                    </h4>
                    <p style={styles.featureDesc}>
                      Connect with active recruiters, startups, MSMEs, and
                      enterprises hiring across multiple industries through
                      verified employer intelligence.
                    </p>
                  </div>
                </div>

                {/* Feature 2 */}
                <div className="feature-item-hover" style={styles.featureItem}>
                  <div className="feature-item-bar" />
                  <div
                    className="feature-icon-hover"
                    style={styles.featureIconWrap}
                  >
                    <Briefcase style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div>
                    <h4
                      className="font-sans feature-title-hover"
                      style={styles.featureTitle}
                    >
                      1,000+ Active Job Opportunities Every Month
                    </h4>
                    <p style={styles.featureDesc}>
                      Give students access to fresh internship, apprenticeship,
                      and full-time opportunities from companies across India.
                    </p>
                  </div>
                </div>

                {/* Feature 3 */}
                <div className="feature-item-hover" style={styles.featureItem}>
                  <div className="feature-item-bar" />
                  <div
                    className="feature-icon-hover"
                    style={styles.featureIconWrap}
                  >
                    <Brain style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div>
                    <h4
                      className="font-sans feature-title-hover"
                      style={styles.featureTitle}
                    >
                      AI Interview Readiness from Real Job Descriptions
                    </h4>
                    <p style={styles.featureDesc}>
                      Bridge the gap between outdated university syllabi and
                      evolving industry expectations. Generate AI-powered
                      interview questions, identify skill gaps, and prepare
                      students for the roles companies are hiring for.
                    </p>
                  </div>
                </div>

                {/* Feature 4 */}
                <div className="feature-item-hover" style={styles.featureItem}>
                  <div className="feature-item-bar" />
                  <div
                    className="feature-icon-hover"
                    style={styles.featureIconWrap}
                  >
                    <FileText style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div>
                    <h4
                      className="font-sans feature-title-hover"
                      style={styles.featureTitle}
                    >
                      FREE ATS Resume Masterclass
                    </h4>
                    <p style={styles.featureDesc}>
                      Exclusive live sessions to help students build
                      ATS-friendly resumes, improve ATS scores, align with
                      industry hiring standards, and maximize interview
                      shortlisting.
                    </p>
                  </div>
                </div>

                <style>{`
  .feature-item-hover {
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  .feature-item-hover:hover {
    border-color: rgba(255, 95, 20, 0.3) !important;
    box-shadow: 0 20px 25px -5px rgba(255, 95, 20, 0.05) !important;
  }

  .feature-item-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: #FF5F14;
    transform: scaleY(0);
    transform-origin: center;
    transition: transform 0.3s ease;
  }
  .feature-item-hover:hover .feature-item-bar {
    transform: scaleY(1);
  }

  .feature-icon-hover {
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  .feature-item-hover:hover .feature-icon-hover {
    background-color: #FF5F14 !important;
    color: #fff !important;
  }

  .feature-title-hover {
    transition: color 0.3s ease;
  }
  .feature-item-hover:hover .feature-title-hover {
    color: #FF5F14 !important;
  }
`}</style>
              </div>

              <div className="mt-4">
                <a
                  href="/about-edu#request-demo"
                  className="orangeBtn"
                  style={styles.exploreBtn}
                >
                  <span>Schedule Demo</span>
                  <ArrowRight style={{ width: "16px", height: "16px" }} />
                </a>
              </div>
            </div>

            {/* Right: Beautiful 300+ Leads Interactive Graphic */}
            <div className="col-lg-6 d-flex justify-content-center py-5">
              <div style={styles.leadsGraphicCircle}>
                <div style={styles.leadsDashedBorder} />

                <div
                  className="text-center p-4 position-relative"
                  style={{ zIndex: 10 }}
                >
                  <div style={styles.leadsIconWrap}>
                    <Briefcase style={{ width: "32px", height: "32px" }} />
                  </div>
                  <h3 className="font-display" style={styles.leadsTitle}>
                    300+ Leads
                  </h3>
                  <p style={styles.leadsSubtext}>Delivered Monthly</p>
                </div>

                {/* Floating Rate Badge */}
                <div style={styles.rateBadge}>
                  <div style={styles.rateIconWrap}>
                    <CheckCircle2 style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div className="text-left">
                    <p style={styles.badgeLabel}>Placement Rate</p>
                    <p style={styles.badgeValue}>94.2% Verified</p>
                  </div>
                </div>

                {/* Floating Student Badge */}
                <div style={styles.studentBadge}>
                  <div style={styles.studentIconWrap}>
                    <Users style={{ width: "20px", height: "20px" }} />
                  </div>
                  <div className="text-left">
                    <p style={styles.badgeLabel}>Active Students</p>
                    <p style={styles.badgeValue}>1,250+ Profiles</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Bento Section */}
      <section
        className="position-relative overflow-hidden"
        style={styles.section}
      >
        {/* Background micro grid */}
        <div className="position-absolute" style={styles.gridOverlay} />

        <div
          className=" container position-relative mx-auto"
          style={styles.container}
        >
          <div className="text-center mx-auto" style={styles.header}>
            <span
              className="d-inline-flex align-items-center gap-2 text-uppercase fw-bold font-mono"
              style={styles.eyebrow}
            >
              <Sparkles
                style={{ width: "12px", height: "12px", color: "#FF5F14" }}
              />
              PLATFORM CAPABILITIES
            </span>
            <p className="font-display heading" style={styles.heading}>
              Engineered for Enterprise Academic Operations
            </p>
            <p className="subtext" style={styles.subtext}>
              Say goodbye to legacy software barriers. Explore standard visual
              controllers designed with high-density layouts and performance
              focus.
            </p>
          </div>

          <div className="row g-4">
            {/* Card 1: One Click Student Interest on Campus Drive */}
            <div className="col-12 col-lg-4">
              <div
                className="d-flex flex-column card-hover justify-content-between bg-white h-100"
                style={styles.card}
              >
                <div style={styles.cardHeader}>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="flex-shrink-0 shadow-sm"
                      style={styles.iconBox}
                    >
                      <MousePointerClick
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                    <h3 className="font-sans" style={styles.cardTitle}>
                      One Click Student Interest on Campus Drive
                    </h3>
                  </div>
                  <p className="cardDesc" style={styles.cardDesc}>
                    Traditionally College TPOs are collecting student interest
                    for job via WhatsApp and Google Form. EduConnectPro
                    simplifies this into a unified, secure, one-click registry.
                  </p>
                </div>

                {/* Interactive One-Click Simulator */}
                <div
                  className="text-start position-relative shadow-sm"
                  style={styles.simulator}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      className="text-uppercase fw-bold"
                      style={styles.simLabel}
                    >
                      Live Student Console
                    </span>
                    <span
                      className="d-inline-flex align-items-center gap-2 text-uppercase fw-bold"
                      style={styles.simBadge}
                    >
                      <span style={styles.pingDot} />
                      Interactive Simulator
                    </span>
                  </div>

                  <div className="position-relative" style={styles.jobCard}>
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="d-flex align-items-center justify-content-center flex-shrink-0 fw-bold shadow-sm"
                          style={styles.jobAvatar}
                        >
                          A
                        </div>
                        <div>
                          <h4
                            className="text-uppercase fw-bold"
                            style={styles.jobTitle}
                          >
                            ARD Systems
                          </h4>
                          <p className="fw-bold" style={styles.jobSubtitle}>
                            Systems Engineer Intern • R&D
                          </p>
                        </div>
                      </div>
                      <span className="fw-bold" style={styles.jobSalary}>
                        4.5 LPA
                      </span>
                    </div>

                    <div
                      className="d-flex flex-wrap gap-2"
                      style={{ paddingTop: "0.25rem" }}
                    >
                      <span className="fw-bold" style={styles.tag}>
                        CS / IT / ECE
                      </span>
                      <span className="fw-bold" style={styles.tag}>
                        CGPA &gt; 8.0
                      </span>
                      <span className="fw-bold" style={styles.tagVerified}>
                        Verified Bio
                      </span>
                    </div>

                    {/* Student Persona Mini Card */}
                    <div
                      className="d-flex align-items-center justify-content-between fw-semibold"
                      style={styles.studentCard}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="d-flex align-items-center justify-content-center text-uppercase fw-bold shadow-sm"
                          style={styles.studentAvatar}
                        >
                          SK
                        </div>
                        <div>
                          <p className="fw-bold" style={styles.studentName}>
                            Siddharth Kapoor
                          </p>
                          <p
                            className="text-uppercase fw-bold"
                            style={styles.studentMeta}
                          >
                            CGPA: 9.12 • No Backlogs
                          </p>
                        </div>
                      </div>
                      <span
                        className="text-uppercase fw-bold"
                        style={styles.eligibleBadge}
                      >
                        Eligible
                      </span>
                    </div>

                    <div style={{ paddingTop: "0.25rem" }}>
                      {studentInterestStatus === "idle" && (
                        <button
                          onClick={handleSimulateStudentInterest}
                          className="w-100 orangeBtn d-flex align-items-center interestButton justify-content-center gap-2 text-uppercase fw-bold text-center border-0"
                          style={styles.interestButton}
                        >
                          <MousePointerClick
                            style={{ width: "14px", height: "14px" }}
                          />
                          Express Interest with 1-Click
                        </button>
                      )}

                      {studentInterestStatus === "submitting" && (
                        <button
                          disabled
                          className="w-100 d-flex align-items-center justify-content-center gap-2 text-uppercase fw-bold text-center border-0"
                          style={styles.submittingButton}
                        >
                          <div style={styles.spinner} />
                          Syncing Secure Registry...
                        </button>
                      )}

                      {studentInterestStatus === "done" && (
                        <div
                          className="w-100 d-flex align-items-center justify-content-center gap-2 text-uppercase fw-bold text-center"
                          style={styles.doneBox}
                        >
                          <CheckCircle2
                            style={{
                              width: "16px",
                              height: "16px",
                              color: "#059669",
                              flexShrink: 0,
                            }}
                          />
                          Interest Registered!
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Simulated Real-Time Applied Ticker */}
                  <div
                    className="d-flex align-items-center justify-content-between fw-bold"
                    style={styles.ticker}
                  >
                    <div className="d-flex" style={styles.avatarStack}>
                      <span
                        className="d-flex align-items-center justify-content-center text-uppercase fw-bold"
                        style={styles.avatarBlue}
                      >
                        AJ
                      </span>
                      <span
                        className="d-flex align-items-center justify-content-center text-uppercase fw-bold"
                        style={styles.avatarPurple}
                      >
                        KM
                      </span>
                      <span
                        className="d-flex align-items-center justify-content-center text-uppercase fw-bold"
                        style={styles.avatarAmber}
                      >
                        PT
                      </span>
                      <span
                        className="d-flex align-items-center justify-content-center fw-bold"
                        style={styles.avatarMore}
                      >
                        +342
                      </span>
                    </div>
                    <span className="fw-bold" style={{ color: "#94a3b8" }}>
                      {studentInterestStatus === "done"
                        ? "343 Students Registered"
                        : "342 Students Registered"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Three-Way Real-time Portal Sync */}
            <div className="col-12 col-lg-4">
              <div
                className="d-flex card-hover flex-column justify-content-between bg-white h-100"
                style={styles.card}
              >
                <div style={styles.cardHeader}>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="flex-shrink-0 shadow-sm"
                      style={styles.iconBox}
                    >
                      <Layers style={{ width: "20px", height: "20px" }} />
                    </div>
                    <h3 className="font-sans" style={styles.cardTitle}>
                      Three-Way Real-time Portal Sync
                    </h3>
                  </div>
                  <p className="cardDesc" style={styles.cardDesc}>
                    Experience a cohesive institutional system with separate
                    dashboard ports for Students, Placement Directors (TPOs),
                    and Recruiter Heads. Data changes propagate across portals
                    instantly.
                  </p>
                </div>

                {/* Interactive Portal Switcher Simulator */}
                <div
                  className="text-start position-relative shadow-sm"
                  style={styles.simulator}
                >
                  {/* Switcher Tabs */}
                  <div className="row g-1" style={styles.tabGroup}>
                    {["recruiter", "tpo", "student"].map((tab) => (
                      <div className="col-4" key={tab}>
                        <button
                          onClick={() => setCapPortal(tab)}
                          className="w-100 text-uppercase text-center border-0"
                          style={{
                            ...styles.tabButton,
                            ...(capPortal === tab
                              ? styles.tabButtonActive
                              : styles.tabButtonInactive),
                          }}
                        >
                          {tab === "student"
                            ? "Student"
                            : tab === "recruiter"
                              ? "Recruiter"
                              : "TPO"}
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* Dashboard Metrics Layout */}
                  <div className="row g-2">
                    {/* Metric 1 */}
                    <div className="col-4">
                      <div
                        className="bg-white shadow-sm"
                        style={styles.metricCard}
                      >
                        <span
                          className="text-uppercase d-block"
                          style={styles.metricLabel}
                        >
                          Total Drives
                        </span>
                        <div className="d-flex align-items-baseline gap-1">
                          <span style={styles.metricValue}>48</span>
                          <span style={styles.metricDelta}>+12%</span>
                        </div>
                        <span className="d-block" style={styles.metricSub}>
                          Arranged
                        </span>
                      </div>
                    </div>

                    {/* Metric 2 */}
                    <div className="col-4">
                      <div
                        className="bg-white shadow-sm"
                        style={styles.metricCard}
                      >
                        <span
                          className="text-uppercase d-block"
                          style={styles.metricLabel}
                        >
                          Engaged Students
                        </span>
                        <div className="d-flex align-items-baseline gap-1">
                          <span style={styles.metricValue}>1,280</span>
                        </div>
                        <span className="d-block" style={styles.metricSub}>
                          In Placement
                        </span>
                      </div>
                    </div>

                    {/* Metric 3 */}
                    <div className="col-4">
                      <div
                        className="bg-white shadow-sm"
                        style={styles.metricCard}
                      >
                        <span
                          className="text-uppercase d-block"
                          style={styles.metricLabel}
                        >
                          Success Rate
                        </span>
                        <div className="d-flex align-items-baseline gap-1">
                          <span style={styles.metricValueGreen}>91.2%</span>
                        </div>
                        <span className="d-block" style={styles.metricSub}>
                          Drive Metrics
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Portal Live Sync Detail View */}
                  <div className="bg-white shadow-sm" style={styles.syncPanel}>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={styles.syncHeader}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span style={styles.pulseDot} />
                        <span
                          className="text-uppercase fw-bold"
                          style={styles.syncLabel}
                        >
                          {capPortal === "recruiter" && "Recruiter API Port"}
                          {capPortal === "tpo" && "TPO Command Center"}
                          {capPortal === "student" && "Student"}
                        </span>
                      </div>
                      <span
                        className="text-uppercase fw-bold"
                        style={styles.syncCount}
                      >
                        2 Lac+ Freshers
                      </span>
                    </div>

                    {capPortal === "recruiter" && (
                      <div
                        className="d-flex flex-column gap-2"
                        style={{ fontSize: "0.75rem" }}
                      >
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Recruiter Filter:</span>
                          <span
                            className="fw-bold"
                            style={{ color: "#020617" }}
                          >
                            &gt; 8.0 CGPA • Verified Only
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Target Candidates Matching:</span>
                          <span style={styles.matchBadge}>318 Students</span>
                        </div>
                      </div>
                    )}

                    {capPortal === "tpo" && (
                      <div
                        className="d-flex flex-column gap-2"
                        style={{ fontSize: "0.75rem" }}
                      >
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Drive Coordinator:</span>
                          <span
                            className="fw-bold"
                            style={{ color: "#020617" }}
                          >
                            Prof. Sharma (TPO Head)
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Active Pipeline Stage:</span>
                          <span
                            className="d-flex align-items-center gap-1 fw-bold"
                            style={{ color: "#020617" }}
                          >
                            <CheckCircle2
                              style={{
                                width: "14px",
                                height: "14px",
                                color: "#059669",
                              }}
                            />{" "}
                            Express Interest Live
                          </span>
                        </div>
                      </div>
                    )}

                    {capPortal === "student" && (
                      <div
                        className="d-flex flex-column gap-2"
                        style={{ fontSize: "0.75rem" }}
                      >
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Student Verification State:</span>
                          <span
                            className="fw-bold"
                            style={styles.verifiedBadge}
                          >
                            100% Academic Locked
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Mobile App Stats:</span>
                          <span
                            className="fw-bold"
                            style={{ color: "#020617" }}
                          >
                            96,000 Download
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between fw-semibold"
                          style={{ color: "#64748b" }}
                        >
                          <span>Total Jobs Posted:</span>
                          <span
                            className="fw-bold"
                            style={{ color: "#020617" }}
                          >
                            25,000 Jobs Posted
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    className="text-center fw-semibold"
                    style={styles.footNote}
                  >
                    ⚡ Switching ports simulates immediate, zero-lag cloud
                    database sync across different user-roles.
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: High-Velocity Campaign Broadcaster */}
            <div className="col-12 col-lg-4">
              <div
                className="d-flex card-hover flex-column justify-content-between bg-white h-100"
                style={styles.card}
              >
                <div style={styles.cardHeader}>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="flex-shrink-0 shadow-sm"
                      style={styles.iconBox}
                    >
                      <Zap style={{ width: "20px", height: "20px" }} />
                    </div>
                    <h3 className="font-sans" style={styles.cardTitle}>
                      High-Velocity Campaign Broadcaster
                    </h3>
                  </div>
                  <p className="cardDesc" style={styles.cardDesc}>
                    Declare recruiter drives, perform instantaneous automatic
                    eligibility checking, and broadcast smart application hooks
                    to target student groups via WhatsApp & Email channels on
                    command.
                  </p>
                </div>

                {/* Interactive Dispatcher Simulator */}
                <div
                  className="text-start position-relative shadow-sm"
                  style={styles.simulator}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      className="text-uppercase"
                      style={styles.simLabelMono}
                    >
                      Broadcast Console
                    </span>
                    <span
                      className="d-inline-flex align-items-center gap-1 text-uppercase fw-bold"
                      style={{
                        ...styles.dispatchBadge,
                        ...(capDispatch === "idle"
                          ? styles.dispatchIdle
                          : capDispatch === "processing"
                            ? styles.dispatchProcessing
                            : styles.dispatchSent),
                      }}
                    >
                      {capDispatch === "idle"
                        ? "● Ready"
                        : capDispatch === "processing"
                          ? "● Sending..."
                          : "● Broadcast Complete"}
                    </span>
                  </div>

                  {/* Channels Status Panel */}
                  <div className="d-flex gap-2 justify-content-between">
                    <div
                      className="flex-fill text-center bg-white shadow-sm"
                      style={styles.channelBox}
                    >
                      <span
                        className="text-uppercase d-block"
                        style={styles.channelLabel}
                      >
                        WhatsApp API
                      </span>
                      <span
                        style={{
                          ...styles.channelDot,
                          backgroundColor: "#10b981",
                        }}
                      />
                      <span className="fw-bold" style={styles.channelStatus}>
                        ACTIVE
                      </span>
                    </div>
                    <div
                      className="flex-fill text-center bg-white shadow-sm"
                      style={styles.channelBox}
                    >
                      <span
                        className="text-uppercase d-block"
                        style={styles.channelLabel}
                      >
                        Email SMTP
                      </span>
                      <span
                        style={{
                          ...styles.channelDot,
                          backgroundColor: "#3b82f6",
                        }}
                      />
                      <span className="fw-bold" style={styles.channelStatus}>
                        ACTIVE
                      </span>
                    </div>
                    <div
                      className="flex-fill text-center bg-white shadow-sm"
                      style={styles.channelBox}
                    >
                      <span
                        className="text-uppercase d-block"
                        style={styles.channelLabel}
                      >
                        Push Gateway
                      </span>
                      <span
                        style={{
                          ...styles.channelDot,
                          backgroundColor: "#FF5F14",
                        }}
                      />
                      <span className="fw-bold" style={styles.channelStatus}>
                        ACTIVE
                      </span>
                    </div>
                  </div>

                  {/* Campaign Visual Board */}
                  <div
                    className="position-relative d-flex flex-column justify-content-center bg-white"
                    style={styles.campaignBoard}
                  >
                    {capDispatch === "idle" && (
                      <div className="d-flex flex-column gap-2">
                        <div
                          className="d-flex justify-content-between align-items-center fw-bold"
                          style={styles.campaignHeader}
                        >
                          <span>Campaign: ARD Systems Drive Target</span>
                          <span>CS/IT/ECE</span>
                        </div>
                        <p className="fw-bold" style={styles.campaignText}>
                          Declare campaign targeting students matching:{" "}
                          <span style={{ color: "#020617", fontWeight: 900 }}>
                            CGPA &gt;= 8.0
                          </span>{" "}
                          & CS/IT/ECE branch.
                        </p>
                        <div
                          className="fw-semibold"
                          style={styles.campaignFootnote}
                        >
                          ⚡ Simulator automatically dispatches target-group
                          campaigns periodically.
                        </div>
                      </div>
                    )}

                    {capDispatch === "processing" && (
                      <div className="text-center d-flex flex-column gap-3">
                        <div
                          className="mx-auto"
                          style={styles.dispatchSpinner}
                        />
                        <p className="fw-bold" style={styles.processingText}>
                          Matching eligibility matrix and firing messages...
                        </p>
                      </div>
                    )}

                    {capDispatch === "sent" && (
                      <div className="d-flex flex-column gap-3">
                        <div
                          className="d-flex align-items-center gap-2"
                          style={styles.sentHeader}
                        >
                          <CheckCircle2
                            style={{
                              width: "16px",
                              height: "16px",
                              color: "#059669",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            className="text-uppercase"
                            style={styles.sentLabel}
                          >
                            318 Messages Piped
                          </span>
                        </div>

                        {/* Simulated Phone Message Bubble */}
                        <div className="bg-white" style={styles.messageBubble}>
                          <div
                            className="d-flex justify-content-between fw-bold"
                            style={styles.messageMeta}
                          >
                            <span>WhatsApp • Siddharth K.</span>
                            <span>Just now</span>
                          </div>
                          <p className="fw-medium" style={styles.messageText}>
                            "Hi Siddharth, ARD Systems is hiring Systems
                            Engineer Interns! Apply in 1-click on your Freshment
                            App."
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style>{`
    @keyframes ping {
      75%, 100% { transform: scale(2); opacity: 0; }
    }
    @keyframes bento-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    @keyframes bento-pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
  `}</style>
      </section>

      {/* Testimonials Section */}
      <section
        className=" container testimonial_section position-relative overflow-hidden"
        style={styles.testimonial_section}
      >
        <div
          className="position-absolute"
          style={styles.testimonial_gridOverlay}
        />

        <div
          className="container position-relative mx-auto"
          style={styles.testimonial_container}
        >
          <div
            className="text-center mx-auto"
            style={styles.testimonial_header}
          >
            <span
              className="text-uppercase d-inline-block"
              style={styles.testimonial_eyebrow}
            >
              TESTIMONIALS
            </span>
            <p
              className="font-display testimonial_heading"
              style={styles.testimonial_heading}
            >
              Validated by Leading Placement Officers & Recruiter Heads
            </p>
            <p className="subtext" style={styles.testimonial_subtext}>
              Read how campuses and recruiters are transforming legacy
              spreadsheets into high-velocity career placements.
            </p>
          </div>

          {/* Testimonials Section JSX */}
          <div
            className="position-relative testimonial-viewport"
            style={styles.testimonialViewport}
          >
            {testimonialsLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : testimonials.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">
                  No testimonials available at the moment.
                </p>
              </div>
            ) : (
              <div
                className="testimonial-track"
                style={{
                  display: "flex",
                  gap: "1.1rem",
                  transform: `translateX(-${testimonialIndex * (100 / cardsPerView)}%)`,
                  transition: isTransitioning ? "transform 0.6s ease" : "none",
                }}
              >
                {extendedTestimonials.map((test, index) => (
                  <div
                    key={index}
                    style={{ flex: `0 0 calc(${100 / cardsPerView}% - 1rem)` }}
                  >
                    <div
                      className="position-relative d-flex flex-column justify-content-between bg-white shadow-sm h-100 testimonial_card"
                      style={styles.testimonial_card}
                    >
                      {/* Decorative absolute quotes graphic */}
                      <span
                        className="position-absolute testimonial_quoteMark"
                        style={styles.testimonial_quoteMark}
                      >
                        &ldquo;
                      </span>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        {/* Rating Stars */}
                        <div className="d-flex gap-1">
                          {[...Array(test.rating || 5)].map((_, i) => (
                            <svg
                              key={i}
                              style={{
                                width: "16px",
                                height: "16px",
                                color: "#fbbf24",
                                fill: "currentColor",
                              }}
                              viewBox="0 0 20 20"
                            >
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>

                        <p
                          className="fw-semibold position-relative"
                          style={styles.testimonial_quote}
                        >
                          "{test.quote}"
                        </p>
                      </div>

                      <div
                        className="d-flex align-items-center gap-3"
                        style={styles.testimonial_footer}
                      >
                        {test.profile_picture ? (
                          <img
                            src={test.profile_picture}
                            alt={test.author}
                            className="flex-shrink-0 shadow-sm"
                            style={styles.testimonial_avatar}
                          />
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center flex-shrink-0 shadow-sm"
                            style={styles.testimonial_avatar}
                          >
                            {test.author ? test.author.charAt(0) : "?"}
                          </div>
                        )}
                        <div>
                          <h4
                            className="fw-bold"
                            style={styles.testimonial_author}
                          >
                            {test.author || "Anonymous"}
                          </h4>
                          <p
                            className="text-uppercase fw-bold"
                            style={styles.testimonial_role}
                          >
                            {test.role || "User"}
                          </p>
                          <p
                            className="font-mono"
                            style={styles.testimonial_org}
                          >
                            {test.org || "Organization"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <style>{`
    .testimonial_card:hover {
      border-color: rgba(255, 95, 20, 0.2) !important;
      box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1) !important;
      transform: translateY(-4px);
    }
    .testimonial_card:hover .testimonial_quoteMark {
      color: #fff7ed !important;
    }
    .testimonial_card:hover .testimonial_avatarInner {
      transform: scale(1.05);
    }
      testimonialViewport: {
  overflow: "hidden"
}
  
  
  `}</style>
      </section>

      {/* supported by from talent connect */}
      <section
        className=" container testimonial_section position-relative overflow-hidden"
        style={styles.incubated_section}
      >
        <div
          className="position-absolute"
          style={styles.testimonial_gridOverlay}
        />
        <div className="px-4 position-relative my-5" style={{ zIndex: 1 }}>
          <div className="d-flex flex-column align-items-center w-100">
            <div
              className="text-center mx-auto mb-4"
              style={{ maxWidth: "48rem" }}
            >
              <span
                className="text-uppercase d-inline-block"
                style={styles.testimonial_eyebrow}
              >
                Supported & Incubated By
              </span>
            </div>

            <style>
              {`
        .marquee-swiper .swiper-wrapper {
          transition-timing-function: linear !important;
        }
      `}
            </style>
            <Swiper
              className="marquee-swiper container"
              style={{ width: "100%", height: "100px", marginTop: "10px" }}
              modules={[Autoplay]}
              spaceBetween={50}
              slidesPerView={5}
              loop={true}
              speed={5000}
              allowTouchMove={false}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                480: { slidesPerView: 2 },
                640: { slidesPerView: 3 },
                960: { slidesPerView: 4 },
                1140: { slidesPerView: 5 },
              }}
            >
              {supportersImage.map((si) => (
                <SwiperSlide
                  key={si.name}
                  className="flex justify-center items-center"
                >
                  <img
                    src={si.src}
                    alt={si.name}
                    style={{
                      height: "56px",
                      width: "300px",
                      objectFit: "contain",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* cta section */}
      <div
        className="position-relative overflow-hidden"
        style={styles.ctaSection}
      >
        <div style={styles.ctaBgGlow}></div>

        <div
          className="position-relative z-10 mx-auto"
          style={{ maxWidth: "64rem" }}
        >
          <div className="mx-auto position-relative" style={styles.ctaCard}>
            <div style={styles.ctaCardGrid}></div>
            <div style={styles.ctaCardGlow1}></div>
            <div style={styles.ctaCardGlow2}></div>

            <div
              className="position-relative z-10 text-center mx-auto"
              style={{ maxWidth: "48rem", width: "96%" }}
            >
              {/* Premium styled badge */}
              <div
                className="d-inline-flex align-items-center gap-2 text-uppercase fw-bold"
                style={styles.badge}
              >
                <Sparkles
                  style={{ width: "16px", height: "16px", color: "#fb923c" }}
                />
                <span
                  className="fw-bold font-display badgeText"
                  style={styles.badgeText}
                >
                  Enterprise Placement Intelligence SaaS Suite
                </span>
              </div>

              <h2 className="font-display ctaTitle" style={styles.ctaTitle}>
                Ready to Accelerate Your <br className="d-none d-sm-block" />
                <span className="font-display" style={styles.ctaGradientText}>
                  Placement Success?
                </span>
              </h2>

              <p className="ctaDesc" style={styles.ctaDesc}>
                Equip your campus placement cell with unified, modern software.
                Seamless candidate matching, automated communications, and live
                pipeline metrics await.
              </p>

              <div
                className="d-flex flex-column flex-sm-row justify-content-center align-items-center"
                style={{ gap: "1rem", marginTop: "2rem" }}
              >
                <a
                  href="/about-edu#request-demo"
                  className="orangeBtn"
                  style={styles.ctaPrimaryBtn}
                >
                  <span>Schedule Demo</span>
                  <Calendar size={16} />
                </a>
                <Link
                  to="/about-edu"
                  className="secondary-btn"
                  style={styles.ctaSecondaryBtn}
                >
                  <span>Learn More</span>
                  <ArrowRight size={16} />
                </Link>
              </div>

              <div
                className="d-flex flex-wrap ctaTrustRow justify-content-center align-items-center"
                style={styles.ctaTrustRow}
              >
                <span
                  className="d-flex align-items-center  font-mono"
                  style={{ gap: "6px" }}
                >
                  <ShieldCheck size={14} color="#10b981" />
                  No credit card required
                </span>
                <span
                  className="d-none d-sm-inline"
                  style={{ color: "rgba(255,255,255,0.1)" }}
                >
                  •
                </span>
                <span
                  className="d-flex align-items-center  font-mono"
                  style={{ gap: "6px" }}
                >
                  <Users size={14} color="#FF5F14" />
                  Active across 40+ Universities
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    position: "relative",
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    color: "#0f172a",
    overflow: "hidden",
    fontFamily: "sans-serif",
  },
  glowLeft: {
    position: "absolute",
    top: 0,
    left: "25%",
    width: "24rem",
    height: "24rem",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.05)",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  glowRight: {
    position: "absolute",
    top: "25%",
    right: "25%",
    width: "31.25rem",
    height: "31.25rem",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.03)",
    filter: "blur(150px)",
    pointerEvents: "none",
  },
  glowBottom: {
    position: "absolute",
    bottom: "20%",
    left: "33%",
    width: "20rem",
    height: "20rem",
    borderRadius: "50%",
    backgroundColor: "rgba(249, 115, 22, 0.05)",
    filter: "blur(100px)",
    pointerEvents: "none",
  },

  heroSection: {
    position: "relative",
    paddingTop: "6rem",
    paddingBottom: "4rem",
    zIndex: 10,
  },
  eyebrowBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.375rem 0.75rem",
    borderRadius: "9999px",
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    fontSize: "0.625rem",
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "#FF5F14",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
    marginBottom: "1.5rem",
  },
  h1: {
    fontSize: "2.5rem",
    fontWeight: 900,
    color: "#020617",
    letterSpacing: "-0.025em",
    lineHeight: 1.1,
    marginBottom: "1.5rem",
  },
  heroDesc: {
    fontSize: "1rem",
    color: "#64748b",
    lineHeight: 1.625,
    fontWeight: 600,
    marginBottom: "1.5rem",
  },

  trustGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "1rem",
    paddingTop: "1rem",
    borderTop: "1px solid rgba(226, 232, 240, 0.6)",
  },
  trustItem: { display: "flex", alignItems: "center", gap: "0.625rem" },
  trustText: { fontSize: "0.75rem", fontWeight: 700, color: "#334155" },

  loginCard: {
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    padding: "2rem",
    borderRadius: "1rem",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    position: "relative",
    overflow: "hidden",
    textAlign: "left",
  },
  loginCardGlow: {
    position: "absolute",
    top: "-20%",
    left: "-20%",
    width: "150px",
    height: "150px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.05)",
    filter: "blur(40px)",
    pointerEvents: "none",
  },
  loginCardTitle: {
    fontSize: "1.25rem",
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-0.025em",
    margin: 0,
  },
  loginCardSubtext: {
    fontSize: "0.75rem",
    color: "#64748b",
    marginTop: "0.25rem",
  },
  formLabel: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#334155",
    display: "block",
    marginBottom: "0.375rem",
  },
  inputWrapper: { position: "relative" },
  inputIcon: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    paddingLeft: "0.875rem",
    color: "#94a3b8",
  },
  inputField: {
    width: "100%",
    paddingLeft: "2.5rem",
    paddingRight: "2.5rem",
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem",
    backgroundColor: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "0.75rem",
    fontSize: "0.875rem",
    color: "#0f172a",
    fontWeight: 500,
    outline: "none",
    transition: "border-color 0.2s",
  },
  forgotLink: {
    fontSize: "0.6875rem",
    color: "#FF5F14",
    fontWeight: 600,
    textDecoration: "none",
  },
  eyeBtn: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    paddingRight: "0.75rem",
    color: "#94a3b8",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  checkbox: { width: "1rem", height: "1rem", cursor: "pointer" },
  checkboxLabel: {
    marginLeft: "0.5rem",
    fontSize: "0.6875rem",
    color: "#64748b",
    fontWeight: 700,
    cursor: "pointer",
    userSelect: "none",
    marginBottom: "0",
  },
  submitButton: {
    width: "100%",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 10px 15px -3px rgba(255, 95, 20, 0.1)",
  },

  superchargeSection: {
    padding: "5rem 0",
    borderBottom: "1px solid #e2e8f0",
    backgroundColor: "rgba(248, 250, 252, 0.4)",
    position: "relative",
    overflow: "hidden",
  },
  superchargeDeco: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "33.333%",
    height: "100%",
    backgroundColor: "rgba(255, 237, 213, 0.2)",
    transform: "skewX(-12deg)",
    transformOrigin: "top right",
    pointerEvents: "none",
  },
  superchargeEyebrow: {
    display: "inline-block",
    color: "#FF5F14",
    fontWeight: 800,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    fontSize: "0.75rem",
    backgroundColor: "#fff7ed",
    border: "1px solid #ffedd5",
    padding: "0.375rem 0.75rem",
    borderRadius: "9999px",
    marginBottom: "1.5rem",
  },
  h2: {
    fontSize: "2rem",
    fontWeight: 800,
    color: "#0f172a",
    letterSpacing: "-0.025em",
    marginBottom: "1rem",
    lineHeight: 1.2,
  },
  superchargeDesc: {
    fontSize: "1rem",
    color: "#475569",
    lineHeight: 1.625,
    fontWeight: 600,
    marginBottom: "1.5rem",
  },
  featuresList: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    paddingTop: "0.5rem",
  },
  featureItem: {
    display: "flex",
    gap: "1rem",
    padding: "1.25rem",
    borderRadius: "1rem",
    backgroundColor: "#fff",
    border: "1px solid rgba(226, 232, 240, 0.85)",
    transition: "all 0.3s",
  },
  featureIconWrap: {
    backgroundColor: "#fff7ed",
    color: "#FF5F14",
    padding: "0.75rem",
    borderRadius: "0.75rem",
    border: "1px solid rgba(255, 237, 213, 0.6)",
    flexShrink: 0,
    height: "fit-content",
  },
  featureTitle: {
    fontSize: "0.875rem",
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 0.25rem 0",
  },
  featureDesc: {
    fontSize: "0.75rem",
    color: "#64748b",
    fontWeight: 500,
    lineHeight: 1.625,
    margin: 0,
  },
  exploreBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
    backgroundColor: "#FF5F14",
    color: "#fff",
    fontWeight: 700,
    padding: "0.75rem 1.5rem",
    borderRadius: "0.75rem",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    textDecoration: "none",
    boxShadow: "0 4px 6px -1px rgba(255, 95, 20, 0.1)",
  },

  leadsGraphicCircle: {
    position: "relative",
    width: "100%",
    maxWidth: "24rem",
    aspectRatio: "1 / 1",
    background: "linear-gradient(to bottom right, #ffffff, #f8fafc)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    border: "1px solid #f1f5f9",
  },
  leadsDashedBorder: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    border: "1px dashed #fed7aa",
    animation: "spin 12s linear infinite",
  },
  leadsIconWrap: {
    width: "4rem",
    height: "4rem",
    backgroundColor: "rgba(255, 237, 213, 0.5)",
    color: "#FF5F14",
    borderRadius: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1rem",
    border: "1px solid #ffedd5",
  },
  leadsTitle: {
    fontSize: "1.875rem",
    fontWeight: 900,
    color: "#0f172a",
    letterSpacing: "-0.025em",
    margin: 0,
  },
  leadsSubtext: {
    fontSize: "0.75rem",
    color: "#64748b",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginTop: "0.25rem",
  },
  rateBadge: {
    position: "absolute",
    top: "2rem",
    right: "-1rem",
    backgroundColor: "#fff",
    padding: "0.875rem",
    borderRadius: "1rem",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    border: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  rateIconWrap: {
    backgroundColor: "#ecfdf5",
    padding: "0.5rem",
    borderRadius: "50%",
    color: "#059669",
  },
  badgeLabel: {
    fontSize: "0.625rem",
    color: "#94a3b8",
    fontWeight: 800,
    textTransform: "uppercase",
    margin: 0,
  },
  badgeValue: {
    fontWeight: 800,
    color: "#0f172a",
    fontSize: "0.875rem",
    margin: 0,
  },
  studentBadge: {
    position: "absolute",
    bottom: "2rem",
    left: "-1rem",
    backgroundColor: "#fff",
    padding: "0.875rem",
    borderRadius: "1rem",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    border: "1px solid #f1f5f9",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  studentIconWrap: {
    backgroundColor: "#eff6ff",
    padding: "0.5rem",
    borderRadius: "50%",
    color: "#2563eb",
  },

  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(to right, #80808007 1px, transparent 1px), linear-gradient(to bottom, #80808007 1px, transparent 1px)",
    backgroundSize: "24px 24px",
    pointerEvents: "none",
  },

  section: {
    padding: "6rem 0",
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "rgba(248, 250, 252, 0.4)",
  },
  gridOverlay: {
    inset: 0,
    backgroundImage:
      "linear-gradient(to right, #80808007 1px, transparent 1px), linear-gradient(to bottom, #80808007 1px, transparent 1px)",
    backgroundSize: "24px 24px",
    pointerEvents: "none",
  },
  container: {
    padding: "0 1rem",
  },
  header: {
    maxWidth: "48rem",
    marginBottom: "5rem",
  },
  eyebrow: {
    padding: "0.25rem 0.75rem",
    borderRadius: "9999px",
    backgroundColor: "#fff7ed",
    border: "1px solid #ffedd5",
    fontSize: "12px",
    letterSpacing: "0.05em",
    color: "#FF5F14",
    fontFamily: "monospace",
    marginBottom: "0.75rem",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
  },
  heading: {
    fontSize: "2.25rem",
    fontWeight: 900,
    lineHeight: 1,
    color: "#020617",
    marginBottom: "1rem",
    letterSpacing: "-0.025em",
    fontFamily: "'Space Grotesk', sans-serif",
  },
  subtext: {
    color: "#64748b",
    fontSize: "0.9375rem",
    fontWeight: 600,
    maxWidth: "42rem",
    marginLeft: "auto",
    marginRight: "auto",
  },
  card: {
    borderRadius: "1.5rem",
    border: "1px solid #e2e8f0",
    padding: "2rem",
    transition: "all 0.3s ease",
  },
  cardHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginBottom: "2rem",
  },
  iconBox: {
    padding: "0.625rem",
    borderRadius: "1rem",
    backgroundColor: "#fff7ed",
    color: "#FF5F14",
    border: "1px solid rgba(255, 237, 213, 0.6)",
  },
  cardTitle: {
    fontSize: "1.25rem",
    fontWeight: 900,
    color: "#020617",
    letterSpacing: "-0.025em",
  },
  cardDesc: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: 600,
    lineHeight: 1.625,
  },
  simulator: {
    padding: "1.25rem",
    borderRadius: "1rem",
    backgroundColor: "#f8fafc",
    border: "1px solid #f1f5f9",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    overflow: "hidden",
  },
  simLabel: {
    fontSize: "10px",
    color: "#64748b",
    letterSpacing: "0.05em",
  },
  simLabelMono: {
    fontWeight: "800",
    fontSize: "12px",
    color: "#94a3b8",
    letterSpacing: "0.05em",
    fontFamily: "monospace",
  },
  simBadge: {
    padding: "0.25rem 0.625rem",
    borderRadius: "9999px",
    backgroundColor: "#fff7ed",
    border: "1px solid rgba(255, 237, 213, 0.6)",
    color: "#FF5F14",
    fontSize: "12px",
    letterSpacing: "0.05em",
  },
  pingDot: {
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    backgroundColor: "#FF5F14",
    animation: "ping 1.5s cubic-bezier(0,0,0.2,1) infinite",
  },
  jobCard: {
    padding: "1rem",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    borderRadius: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.875rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.02)",
    transition: "all 0.3s ease",
  },
  jobAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "0.75rem",
    backgroundColor: "rgba(249, 115, 22, 0.1)",
    border: "1px solid rgba(249, 115, 22, 0.2)",
    color: "#FF5F14",
    fontSize: "0.875rem",
  },
  jobTitle: {
    fontSize: "0.75rem",
    color: "#020617",
    letterSpacing: "0.025em",
    margin: 0,
  },
  jobSubtitle: {
    fontSize: "10px",
    color: "#94a3b8",
  },
  jobSalary: {
    fontSize: "11px",
    color: "#FF5F14",
    backgroundColor: "rgba(255, 247, 237, 0.7)",
    border: "1px solid rgba(255, 237, 213, 0.6)",
    padding: "0.25rem 0.5rem",
    borderRadius: "0.5rem",
  },
  tag: {
    fontSize: "9px",
    color: "#64748b",
    backgroundColor: "#f8fafc",
    border: "1px solid #f1f5f9",
    padding: "2px 8px",
    borderRadius: "0.375rem",
  },
  tagVerified: {
    fontSize: "9px",
    color: "#059669",
    backgroundColor: "#ecfdf5",
    border: "1px solid rgba(209, 250, 229, 0.6)",
    padding: "2px 8px",
    borderRadius: "0.375rem",
  },
  studentCard: {
    padding: "0.625rem",
    backgroundColor: "rgba(248, 250, 252, 0.7)",
    borderRadius: "0.75rem",
    border: "1px solid #f1f5f9",
    fontSize: "0.75rem",
    color: "#475569",
  },
  studentAvatar: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#e2e8f0",
    color: "#334155",
    fontSize: "9px",
    border: "1px solid #fff",
  },
  studentName: {
    fontSize: "10.5px",
    color: "#020617",
    margin: 0,
  },
  studentMeta: {
    fontSize: "8.5px",
    color: "#94a3b8",
    letterSpacing: "0.05em",
    margin: 0,
  },
  eligibleBadge: {
    fontSize: "9px",
    color: "#059669",
    letterSpacing: "0.1em",
    backgroundColor: "#ecfdf5",
    border: "1px solid #d1fae5",
    padding: "2px 6px",
    borderRadius: "4px",
  },
  interestButton: {
    backgroundColor: "#FF5F14",
    color: "#fff",
    padding: "0.625rem 1rem",
    borderRadius: "0.75rem",
    fontSize: "10.5px",
    letterSpacing: "0.05em",
    cursor: "pointer",
  },
  submittingButton: {
    backgroundColor: "#f1f5f9",
    color: "#94a3b8",
    padding: "0.625rem 1rem",
    borderRadius: "0.75rem",
    fontSize: "10.5px",
    letterSpacing: "0.05em",
  },
  spinner: {
    width: "14px",
    height: "14px",
    border: "2px solid #cbd5e1",
    borderTopColor: "#FF5F14",
    borderRadius: "50%",
    animation: "bento-spin 0.8s linear infinite",
  },
  doneBox: {
    backgroundColor: "#ecfdf5",
    border: "1px solid rgba(209, 250, 229, 0.6)",
    color: "#047857",
    padding: "0.625rem 1rem",
    borderRadius: "0.75rem",
    fontSize: "10.5px",
    letterSpacing: "0.05em",
  },
  ticker: {
    fontSize: "10px",
    color: "#94a3b8",
    borderTop: "1px solid #f1f5f9",
    paddingTop: "0.625rem",
  },
  avatarStack: {
    marginLeft: "-6px",
  },
  avatarBlue: {
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    border: "2px solid #fff",
    backgroundColor: "#3b82f6",
    color: "#fff",
    fontSize: "8px",
    fontFamily: "monospace",
    marginLeft: "-6px",
  },
  avatarPurple: {
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    border: "2px solid #fff",
    backgroundColor: "#a855f7",
    color: "#fff",
    fontSize: "8px",
    fontFamily: "monospace",
    marginLeft: "-6px",
  },
  avatarAmber: {
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    border: "2px solid #fff",
    backgroundColor: "#f59e0b",
    color: "#fff",
    fontSize: "8px",
    fontFamily: "monospace",
    marginLeft: "-6px",
  },
  avatarMore: {
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    border: "2px solid #fff",
    backgroundColor: "#e2e8f0",
    color: "#475569",
    fontSize: "8px",
    marginLeft: "-6px",
  },
  tabGroup: {
    padding: "0.25rem",
    backgroundColor: "rgba(226, 232, 240, 0.5)",
    borderRadius: "0.75rem",
  },
  tabButton: {
    padding: "0.5rem 0.625rem",
    borderRadius: "0.5rem",
    fontSize: "11px",
    letterSpacing: "0.05em",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "all 0.2s ease",
  },
  tabButtonActive: {
    backgroundColor: "#FF5F14",
    color: "#fff",
    boxShadow: "0 4px 6px -1px rgba(255, 95, 20, 0.2)",
  },
  tabButtonInactive: {
    color: "#64748b",
    backgroundColor: "transparent",
  },
  metricCard: {
    padding: "0.75rem",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    borderRadius: "0.75rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    transition: "all 0.3s ease",
  },
  metricLabel: {
    fontSize: "9px",
    color: "#94a3b8",
    letterSpacing: "0.1em",
    lineHeight: 1.2,
  },
  metricValue: {
    fontSize: "1.25rem",
    fontWeight: 900,
    color: "#020617",
    letterSpacing: "-0.025em",
  },
  metricValueGreen: {
    fontSize: "1.25rem",
    fontWeight: 900,
    color: "#059669",
    fontFamily: "monospace",
  },
  metricDelta: {
    fontSize: "8px",
    fontWeight: 900,
    color: "#059669",
    backgroundColor: "#ecfdf5",
    padding: "0 4px",
    borderRadius: "4px",
    fontFamily: "monospace",
  },
  metricSub: {
    fontSize: "9px",
    color: "#94a3b8",
    fontWeight: 700,
    lineHeight: 1,
  },
  syncPanel: {
    padding: "0.875rem",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    borderRadius: "0.75rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.625rem",
  },
  syncHeader: {
    paddingBottom: "0.5rem",
    borderBottom: "1px solid #f8fafc",
  },
  pulseDot: {
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    backgroundColor: "#10b981",
    animation: "bento-pulse 2s ease-in-out infinite",
  },
  syncLabel: {
    fontSize: "9px",
    color: "#94a3b8",
    letterSpacing: "0.05em",
  },
  syncCount: {
    fontSize: "8.5px",
    color: "#94a3b8",
    letterSpacing: "0.05em",
  },
  matchBadge: {
    color: "#FF5F14",
    backgroundColor: "#fff7ed",
    padding: "1px 6px",
    borderRadius: "4px",
    fontFamily: "monospace",
    fontWeight: "800",
  },
  verifiedBadge: {
    color: "#059669",
    backgroundColor: "#ecfdf5",
    border: "1px solid rgba(209, 250, 229, 0.6)",
    padding: "1px 6px",
    borderRadius: "4px",
  },
  footNote: {
    fontSize: "11px",
    color: "#94a3b8",
    lineHeight: 1.625,
    borderTop: "1px solid #f1f5f9",
    paddingTop: "0.625rem",
  },
  dispatchBadge: {
    padding: "0.25rem 0.625rem",
    borderRadius: "9999px",
    fontSize: "9.5px",
    letterSpacing: "0.05em",
    fontFamily: "monospace",
    border: "1px solid transparent",
  },
  dispatchIdle: {
    backgroundColor: "#f1f5f9",
    borderColor: "#e2e8f0",
    color: "#64748b",
  },
  dispatchProcessing: {
    backgroundColor: "#fffbeb",
    borderColor: "#fef3c7",
    color: "#b45309",
    animation: "bento-pulse 2s ease-in-out infinite",
  },
  dispatchSent: {
    backgroundColor: "#ecfdf5",
    borderColor: "#d1fae5",
    color: "#047857",
  },
  channelBox: {
    padding: "0.5rem",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    borderRadius: "0.75rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    boxShadow: "0 2px 10px rgba(0,0,0,0.01)",
  },
  channelLabel: {
    fontSize: "8.5px",
    color: "#94a3b8",
  },
  channelDot: {
    display: "inline-flex",
    height: "6px",
    width: "6px",
    borderRadius: "50%",
    margin: "0 auto",
  },
  channelStatus: {
    fontSize: "8px",
    color: "#020617",
    fontFamily: "monospace",
    marginLeft: "4px",
  },
  campaignBoard: {
    padding: "1rem",
    backgroundColor: "#fff",
    border: "1px solid #f1f5f9",
    borderRadius: "1rem",
    minHeight: "120px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.02)",
    transition: "all 0.3s ease",
  },
  campaignHeader: {
    fontSize: "10px",
    color: "#94a3b8",
    paddingBottom: "0.375rem",
    borderBottom: "1px solid #f8fafc",
  },
  campaignText: {
    fontSize: "11.5px",
    color: "#475569",
    lineHeight: 1.625,
  },
  campaignFootnote: {
    fontSize: "10.5px",
    color: "#94a3b8",
  },
  dispatchSpinner: {
    width: "24px",
    height: "24px",
    border: "2px solid #FF5F14",
    borderTopColor: "transparent",
    borderRadius: "50%",
    animation: "bento-spin 0.8s linear infinite",
  },
  processingText: {
    fontSize: "11px",
    color: "#FF5F14",
    animation: "bento-pulse 2s ease-in-out infinite",
  },
  sentHeader: {
    paddingBottom: "0.5rem",
    borderBottom: "1px solid #f8fafc",
  },
  sentLabel: {
    fontSize: "11px",
    color: "#047857",
  },
  messageBubble: {
    padding: "0.625rem",
    backgroundColor: "#f8fafc",
    border: "1px solid #f1f5f9",
    borderRadius: "0.75rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
  },
  messageMeta: {
    fontSize: "9px",
    color: "#94a3b8",
  },
  messageText: {
    fontSize: "11px",
    color: "#334155",
    lineHeight: 1.5,
  },

  ctaSection: {
    padding: "6rem 0",
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "rgba(248, 250, 252, 0.5)",
  },
  ctaBgGlow: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "700px",
    height: "700px",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.04)",
    filter: "blur(160px)",
    pointerEvents: "none",
  },
  ctaCard: {
    backgroundColor: "#020617",
    color: "white",
    width: "96%",
    borderRadius: "1.5rem",
    padding: "3rem",
    border: "1px solid #1e293b",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    overflow: "hidden",
  },
  ctaCardGrid: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(to right, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.03) 1px, transparent 1px)",
    backgroundSize: "20px 20px",
    pointerEvents: "none",
  },
  ctaCardGlow1: {
    position: "absolute",
    top: "-6rem",
    right: "-6rem",
    width: "20rem",
    height: "20rem",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 95, 20, 0.15)",
    filter: "blur(80px)",
    pointerEvents: "none",
  },
  ctaCardGlow2: {
    position: "absolute",
    bottom: "-6rem",
    left: "-6rem",
    width: "20rem",
    height: "20rem",
    borderRadius: "50%",
    backgroundColor: "rgba(37, 99, 235, 0.1)",
    filter: "blur(80px)",
    pointerEvents: "none",
  },
  badge: {
    padding: "0.5rem 1.25rem",
    borderRadius: "9999px",
    backgroundColor: "rgba(15, 23, 42, 0.85)",
    border: "1px solid rgba(249, 115, 22, 0.3)",
    fontSize: "11px",
    letterSpacing: "0.1em",
    color: "#FF5F14",
    boxShadow: "0 0 20px rgba(255, 95, 20, 0.15)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    margin: "0 auto 30px",
  },
  badgeText: {
    background: "linear-gradient(to right, #fb923c, #fde68a, #fb923c)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  ctaTitle: {
    fontSize: "3rem",
    fontWeight: "900",
    color: "white",
    letterSpacing: "0.02em",
    lineHeight: 1.25,
    marginBottom: "30px",
  },
  ctaGradientText: {
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    color: "transparent",
    backgroundImage: "linear-gradient(to right, white, #fb923c)",
  },
  ctaDesc: {
    fontSize: "1rem",
    color: "#94a3b8",
    lineHeight: 1.625,
    fontWeight: "500",
    margin: "0 auto 30px",
    maxWidth: "36rem",
  },
  ctaPrimaryBtn: {
    padding: "1rem 2rem",
    borderRadius: "0.75rem",
    backgroundColor: "#FF5F14",
    color: "white",
    fontWeight: "900",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    cursor: "pointer",
    boxShadow: "0 10px 15px -3px rgba(255, 95, 20, 0.25)",
  },
  ctaSecondaryBtn: {
    padding: "1rem 2rem",
    borderRadius: "0.75rem",
    backgroundColor: "rgba(255,255,255,0.05)",
    color: "white",
    fontWeight: "900",
    border: "1px solid rgba(255,255,255,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    cursor: "pointer",
  },
  ctaTrustRow: {
    paddingTop: "2.5rem",
    marginTop: "2.5rem",
    borderTop: "1px solid rgba(255,255,255,0.05)",
    gap: "2rem",
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: "#64748b",
  },

  incubated_section: {
    padding: "1rem 0",
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "rgba(248, 250, 252, 0.3)",
  },
  testimonial_section: {
    padding: "6rem 0",
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "rgba(248, 250, 252, 0.3)",
  },
  testimonial_gridOverlay: {
    inset: 0,
    backgroundImage:
      "linear-gradient(to right, #8080800a 1px, transparent 1px), linear-gradient(to bottom, #8080800a 1px, transparent 1px)",
    backgroundSize: "14px 24px",
    maskImage:
      "radial-gradient(ellipse 60% 50% at 50% 0%, #000 70%, transparent 100%)",
    WebkitMaskImage:
      "radial-gradient(ellipse 60% 50% at 50% 0%, #000 70%, transparent 100%)",
    pointerEvents: "none",
  },
  testimonial_container: {
    padding: "0 1rem",
  },
  testimonial_header: {
    maxWidth: "48rem",
    marginBottom: "4rem",
  },
  testimonial_eyebrow: {
    fontSize: "0.75rem",
    fontWeight: "800",
    letterSpacing: "0.1em",
    color: "#FF5F14",
    backgroundColor: "#fff7ed",
    border: "1px solid #ffedd5",
    padding: "0.375rem 0.75rem",
    borderRadius: "9999px",
    marginBottom: "0.75rem",
  },
  testimonial_heading: {
    fontSize: "2.25rem",
    fontWeight: 800,
    color: "#020617",
    marginBottom: "1rem",
    lineHeight: "1.31",
  },
  testimonial_subtext: {
    color: "#64748b",
    fontSize: "0.875rem",
    fontWeight: 600,
    maxWidth: "36rem",
    marginLeft: "auto",
    marginRight: "auto",
  },
  testimonial_card: {
    padding: "2rem",
    borderRadius: "1rem",
    border: "1px solid rgba(226, 232, 240, 0.8)",
    transition: "all 0.3s ease",
  },
  testimonial_quoteMark: {
    top: "1rem",
    right: "1.5rem",
    fontSize: "3.75rem",
    color: "#f1f5f9",
    fontFamily: "serif",
    userSelect: "none",
    pointerEvents: "none",
    transition: "color 0.3s ease",
  },
  testimonial_quote: {
    fontSize: "0.875rem",
    color: "oklch(44.6% 0.043 257.281)",
    fontStyle: "italic",
    lineHeight: 1.625,
    zIndex: 10,
    fontWeight: "600",
  },
  testimonial_footer: {
    borderTop: "1px solid #f1f5f9",
    paddingTop: "1rem",
  },
  testimonial_avatar: {
    width: "48px",
    height: "48px",
    borderRadius: "0.75rem",
    background:
      "linear-gradient(to bottom right, #fff7ed, rgba(255, 237, 213, 0.5))",
    border: "1px solid rgba(254, 215, 170, 0.6)",
    color: "#FF5F14",
    fontWeight: 900,
    fontFamily: "monospace",
    fontSize: "1rem",
    objectFit: "cover",
  },
  testimonial_author: {
    fontSize: "0.8125rem",
    color: "#0f172a",
    margin: 0,
  },
  testimonial_role: {
    fontSize: "10px",
    color: "#64748b",
    letterSpacing: "0.05em",
    margin: 0,
  },
  testimonial_org: {
    fontSize: "11.5px",
    fontWeight: "800",
    color: "#FF5F14",
    marginTop: "0.125rem",
    marginBottom: 0,
  },
};

const mapStateToProps = (state) => ({
  errorMessage: state.auth.errorMessage,
  successMessage: state.auth.successMessage,
  showLoading: state.auth.showLoading,
});

export default connect(mapStateToProps)(Login);
